import { InputTel } from "@sellar-io/components";
import { ReactElement, useState } from "react";
import { useNavigate } from "react-router";
import { Alert } from "../../components/alert/Alert";
import { InputContainer } from "@sellar-io/components";
import { BasicDialog } from "../../components/modal/BasicDialog";
import { ACCOUNT_NOTIFICATION_SETTINGS } from "../../constants/routes";
import { useSellarUser } from "../../hooks";
import { apiV2AssertError } from "../../hooks/api/v2/apiV2Request";
import { useUserUpdate } from "../../hooks/api/v2/user/useUserUpdate";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";
import { Mixpanel } from "../../utils/mixpanel";
import React from "react";

export const SmsDialog = ({
  active,
  onDismiss,
}: {
  active: boolean;
  onDismiss: () => void;
}): ReactElement => {
  const [smsNumber, setSmsNumber] = useState("");
  const { business } = useSellarCurrentBusiness();

  const { user } = useSellarUser();

  if (!user) throw new Error("Cannot find user");

  const userMutation = useUserUpdate(user.id);

  if (!business) throw new Error("Cannot find business");

  const navigate = useNavigate();

  return (
    <BasicDialog
      dialogActive={active}
      confirmButtonText={"Update"}
      onConfirm={() => {
        userMutation.mutate(
          {
            data: {
              smsNumber,
            },
          },
          {
            onSuccess: () => {
              Mixpanel.track("Phone number added", { source: "settings" });
              onDismiss();
              navigate(ACCOUNT_NOTIFICATION_SETTINGS);
              setSmsNumber("");
            },
          },
        );
      }}
      title={"Update phone number"}
      description={`This number will be used as the contact on orders. Other members of ${business.name} can also add their own phone numbers to their account.`}
      loading={userMutation.isPending}
      onDismiss={() => {
        setSmsNumber("");
        onDismiss();
      }}
    >
      {userMutation.isError && (
        <Alert
          type={"error"}
          message={
            apiV2AssertError(userMutation.error)?.response?.data.message ??
            "Unknown error"
          }
        />
      )}
      <InputContainer>
        <InputTel
          disabled={userMutation.isPending}
          required={true}
          value={smsNumber}
          onChange={(e) => setSmsNumber(e.target.value)}
        />
      </InputContainer>
    </BasicDialog>
  );
};
